import { Box, Container, Divider, Typography } from '@mui/material'
import React, { memo } from 'react'
import Option from '../forms/Option'
import { useCreateQuestionMulti } from '../../hooks/useCreateQuestionMulti'
import { modulesType } from '../../constants/modules'
import InputField from '../forms/InputField'

const MultiQuestion = memo(({ dataQuestion, indices, form }) => {
  const options = useCreateQuestionMulti(dataQuestion)
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'} mx={'-1rem'}>
      <Box
        bgcolor={'#9AA5EA'}
        width={'100%'}
        sx={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <Divider
          sx={{
            backgroundColor: 'white',
            height: '3px',
          }}
        />
        <Box px={2} py={3}>
          <Container style={{ display: 'flex', justifyContent: 'center' }}>
            {dataQuestion.link_gambar === '' ? null : (
              <img src={dataQuestion.link_gambar} alt="img-soal" />
            )}
          </Container>
          <Typography
            textAlign={'justify'}
            fontWeight={500}
            fontSize={'14px'}
            color={'white'}
            letterSpacing={1.2}
            lineHeight={1.7}
            sx={{
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
            }}
          >
            {dataQuestion.soal}
          </Typography>
        </Box>
      </Box>
      {/* <Box height={'100%'} pt={5} px={1}>
        {dataQuestion.type_soal !== modulesType.ESSAY ? (
          <Option
            name={`question_${indices}`}
            control={form.control}
            errors={form.formState?.errors}
            options={options}
          />
        ) : (
          <InputField
            name={`question_${indices}`}
            control={form.control}
            errors={form.formState?.errors}
          />
        )}
      </Box> */}
      <Box height={'100%'} pt={5} px={1}>
        {dataQuestion.type_soal !== modulesType.ESSAY ? (
          options.every((opt) => opt.value.startsWith('http')) ||
          ['WU', 'FA'].includes(dataQuestion?.type_soal) ? (
            // Kalau semua option adalah URL gambar → tampil 2 kolom
            <Box display="grid" gridTemplateColumns={{ xs: '1fr 1fr', sm: '1fr 1fr' }} gap={2}>
              {options.map((opt, i) => (
                <Option
                  key={i}
                  name={`question_${indices}`}
                  control={form.control}
                  errors={form.formState?.errors}
                  options={[opt]} // kirim satu-satu
                />
              ))}
            </Box>
          ) : (
            // Default → text biasa 1 kolom
            <Option
              name={`question_${indices}`}
              control={form.control}
              errors={form.formState?.errors}
              options={options}
            />
          )
        ) : (
          <InputField
            name={`question_${indices}`}
            control={form.control}
            errors={form.formState?.errors}
          />
        )}
      </Box>
    </Box>
  )
}, arePropEqual)

function arePropEqual(oldProps, newProps) {
  return oldProps.indices !== newProps.indices
}
export default MultiQuestion
